import { render, staticRenderFns } from "./MetricValueChainTableCell.vue?vue&type=template&id=51ba7cf6"
import script from "./MetricValueChainTableCell.vue?vue&type=script&lang=js"
export * from "./MetricValueChainTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports